(() => {
  const blocks = Array.from(document.querySelectorAll('[data-readmore]'));

  const getParts = (block) => {
    const panel = block.querySelector('[data-readmore-panel]');
    const btn   = block.querySelector('[data-readmore-btn]');
    const text  = block.querySelector('[data-readmore-text]');
    if (!panel || !btn || !text) return null;
    return { panel, btn, text };
  };

  const setButton = (btn, open) => {
    btn.textContent = open ? 'Read less' : 'Read more';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  // Measures heights BUT preserves open/closed state.
  const remeasure = (block) => {
    const parts = getParts(block);
    if (!parts) return;
    const { panel, btn } = parts;

    const isOpen = block.classList.contains('is-open');

    // 1) Measure expanded height (no clamp)
    block.classList.remove('is-collapsed');
    panel.style.maxHeight = 'none';
    panel.offsetHeight;
    const expandedH = panel.scrollHeight;

    // 2) Measure collapsed height (with clamp)
    block.classList.add('is-collapsed');
    panel.offsetHeight;
    const collapsedH = panel.scrollHeight;

    // Store
    panel.dataset.collapsedH = String(collapsedH);
    panel.dataset.expandedH  = String(expandedH);

    // Show/hide button if nothing to expand
    const wrapper = btn.closest('div');
    if (expandedH <= collapsedH + 2) {
      wrapper?.classList.add('hidden');
    } else {
      wrapper?.classList.remove('hidden');
    }

    // Restore state + set correct max-height + label
    if (isOpen) {
      block.classList.remove('is-collapsed');
      block.classList.add('is-open');
      panel.style.maxHeight = expandedH + 'px';
      setButton(btn, true);
    } else {
      block.classList.add('is-collapsed');
      block.classList.remove('is-open');
      panel.style.maxHeight = collapsedH + 'px';
      setButton(btn, false);
    }
  };

  const openBlock = (block) => {
    const parts = getParts(block);
    if (!parts) return;
    const { panel, btn } = parts;

    block.classList.add('is-toggling');

    // Remove clamp first
    block.classList.remove('is-collapsed');

    // Commit style before changing height
    panel.offsetHeight;

    block.classList.add('is-open');
    panel.style.maxHeight = panel.dataset.expandedH + 'px';
    setButton(btn, true);

    const onEnd = (e) => {
      if (e.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', onEnd);
      block.classList.remove('is-toggling');

      // Refresh expanded height in case content reflowed
      panel.dataset.expandedH = String(panel.scrollHeight);
      panel.style.maxHeight = panel.dataset.expandedH + 'px';
    };
    panel.addEventListener('transitionend', onEnd);
  };

  const closeBlock = (block) => {
    const parts = getParts(block);
    if (!parts) return;
    const { panel, btn } = parts;

    block.classList.add('is-toggling');
    block.classList.remove('is-open');

    panel.style.maxHeight = panel.dataset.collapsedH + 'px';
    setButton(btn, false);

    const onEnd = (e) => {
      if (e.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', onEnd);

      // Re-apply clamp after collapsing
      block.classList.add('is-collapsed');
      block.classList.remove('is-toggling');
    };
    panel.addEventListener('transitionend', onEnd);
  };

  const initBlock = (block) => {
    const parts = getParts(block);
    if (!parts) return;
    const { btn } = parts;

    // initial measure (collapsed)
    // ensure default collapsed state
    block.classList.add('is-collapsed');
    block.classList.remove('is-open');
    setButton(btn, false);

    remeasure(block);

    btn.addEventListener('click', () => {
      const open = block.classList.contains('is-open');
      if (open) closeBlock(block);
      else openBlock(block);
    });
  };

  const init = () => blocks.forEach(initBlock);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ✅ Critical fix: ignore "resize" that doesn't change width (mobile address bar)
  let lastW = window.innerWidth;

  const onResize = () => {
    const w = window.innerWidth;
    if (w === lastW) return; // ignore scroll/address-bar resize
    lastW = w;
    blocks.forEach(remeasure);
  };

  window.addEventListener('resize', onResize, { passive: true });

  // ✅ iOS Safari: visualViewport fires on real layout changes more accurately
  if (window.visualViewport) {
    let lastVW = Math.round(window.visualViewport.width);
    window.visualViewport.addEventListener('resize', () => {
      const vw = Math.round(window.visualViewport.width);
      if (vw === lastVW) return;
      lastVW = vw;
      blocks.forEach(remeasure);
    }, { passive: true });
  }
})();
